import { IsEnum, IsNotEmpty, IsString, IsUrl, ValidateIf } from 'class-validator';
import { EventWaiverTypeEnum } from '../../constants';

export class WaiverFormDto {
	@IsEnum(EventWaiverTypeEnum)
	@IsNotEmpty()
	public waiverType?: EventWaiverTypeEnum;

	@ValidateIf((o) => o.waiverType === EventWaiverTypeEnum.Url)
	@IsUrl({}, { message: '"Waiver" link should be a valid URL' })
	@IsNotEmpty({ message: 'Enter a waiver' })
	public waiverUrl?: string | null;

	@ValidateIf(o => o.waiverType === EventWaiverTypeEnum.Text)
	@IsString()
	@IsNotEmpty({ message: 'Enter a waiver' })
	public waiverText?: string | null;
}
